import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthenticationRoutingModule } from "./authentication-routing.module";
import { LoginComponent } from "./login/login.component";
import { ErrorComponent } from "./error/error.component";
import { MaterialModule } from "../material-module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TranslateModule } from "@ngx-translate/core";
import { AccountActivationComponent } from './account-activation/account-activation.component';

@NgModule({
	declarations: [LoginComponent, ErrorComponent, ForgotPasswordComponent, ResetPasswordComponent, AccountActivationComponent],
	imports: [
		CommonModule,
		AuthenticationRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		TranslateModule
	],
})
export class AuthenticationModule {}
